export default {
  KNOWLEDGE_PORTAL: 'KnowledgePortalUser',
  HR: 'HRUser',
  BUSINESS: 'BusinessUser',
  ADMIN: 'AdminUser',
  MI: 'MIUser',
  DOC_SERVICE_USER: 'DocServiceUser',
}
